import { Component, inject, OnInit } from '@angular/core';
import { BuzonService } from '../../../../services/buzon.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { ParticipanteService } from '../../../../services/participante.service';
import { Buzon, BuzonResponsable } from '../../../../models/Buzon';
import { TreeAutocompleteComponent } from '../../../../commons/tree-autocomplete/tree-autocomplete.component';
import { AuthService } from '../../../../services/auth.service';
import { UnidadOrganizacional } from '../../../../models/UnidadOrganizacional';
import { UnidadOrganizacionalService } from '../../../../services/unidad-organizacional.service';
import { MatIconModule } from '@angular/material/icon';
import { map, Observable, startWith } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ServidorPublico } from '../../../../models/ServidorPublico';
import { UltimoUsoPipe } from "../../../../pipes/ultimo-uso.pipe";
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../commons/toast.service';

@Component({
  selector: 'app-buzon-edit',
  imports: [
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule, MatInputModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatToolbarModule,
    MatIconModule,
    AsyncPipe,
    MatTableModule, TreeAutocompleteComponent,
    MatRadioModule, MatCheckboxModule, MatButtonModule,
    UltimoUsoPipe
  ],
  templateUrl: './buzon-edit.component.html',
  styleUrl: './buzon-edit.component.scss',
})
export class BuzonEditComponent implements OnInit {
  departamentoAdminControl = new FormControl('');
  departamentoControl = new FormControl('');
  cargosControl = new FormControl('');
  departamentosControl = new FormControl('');
  participanteControl = new FormControl<string | BuzonResponsable>("");

  funcionariosDataSource = new MatTableDataSource<any>();
  saving = false;
  displayedColumns: string[] = ['titular', 'encargado', 'suscrito', 'funcionario', 'opt'];
  participanteActual: any;
  dptoId: string = '';
  departamentos: any[] = [];
  responsables: BuzonResponsable[] = [];

  participantes: ServidorPublico[] = [];
  participantesFiltered?: Observable<ServidorPublico[]>

  private tokenData = this.authService.getTokenData();
  isAdmin = this.tokenData ? this.tokenData.roles.includes('sgd_admin') : false;

  readonly dialogRef = inject(MatDialogRef<BuzonEditComponent>);
  readonly data = inject<Buzon>(MAT_DIALOG_DATA);

  constructor(
    private authService: AuthService,
    private unidadOrganizacionalService: UnidadOrganizacionalService,
    private participanteService: ParticipanteService,
    private buzonService: BuzonService,
    private toast: ToastService
  ) {
    console.log(this.data);
  }

  ngOnInit(): void {
    if (this.data && this.data.id) {
      this.departamentoControl.setValue(this.data.departamento);
      this.cargosControl.setValue(this.data.cargo);
      this.responsables = this.data.responsables;
      this.funcionariosDataSource.data = this.responsables;
      this.loadFuncionariosForDepartamento(this.data.codigoDepartamento)
    }

    if (this.isAdmin && this.data == null) {
      this.unidadOrganizacionalService.getAllDepartamentosTree().subscribe({
        next: (response) => {
          this.departamentos = response
        }
      })
    }
    if(!this.isAdmin && this.data == null){
      this.unidadOrganizacionalService.getDepartamentosUsuarioActual().subscribe({
        next: (response) => {
          this.departamentos = response
        }
      })
    }
  }


  getServidorPublicoActual() {
    this.buzonService.getServidorPublicoActual().subscribe((servidorPublico: any) => {
      this.participanteActual = servidorPublico;
      this.dptoId = servidorPublico.dptoId;
      this.departamentoControl.setValue(servidorPublico.departamento);
      this.cargosControl.setValue(servidorPublico.cargos);
      this.loadFuncionariosForDepartamento(servidorPublico.dptoId);
    });
  }

  loadFuncionariosForDepartamento(departamentoId: string) {
    this.participanteService.getServidoresPorDepartamento(departamentoId).subscribe((funcionarios: any[]) => {
      const participantesActivos = funcionarios.filter((funcionario: ServidorPublico) => Number(funcionario.estado) === 1);
      this.participantes = participantesActivos;

      if (this.responsables.length > 0) {
        const participantesActivosIds = new Set(this.participantes.map(participante => Number(participante.id)));
        this.responsables = this.responsables.filter(responsable => participantesActivosIds.has(Number(responsable.codigoParticipante)));
        this.funcionariosDataSource.data = [...this.responsables];
      }

      this.participantesFiltered = this.participanteControl.valueChanges.pipe(
        startWith(""),
        map(value => {
          const nombres = typeof value === 'string' ? value : value?.participante;
          return nombres ? this._filterParticipante(nombres as string) : this.participantes.slice();
        }),
      );
    });
  }

  trackDepartamentoChanges(value: any) {
    console.log(value);
    if ((value as UnidadOrganizacional).id) {
      this.departamentoAdminControl.setValue(value);
      this.dptoId = (value as UnidadOrganizacional).id;
      this.departamentoControl.setValue((value as UnidadOrganizacional).nombre);
      this.loadFuncionariosForDepartamento((value as UnidadOrganizacional).id);
    }
  }

  onDepartamentoSelected(event: any) {
    const selectedDepartamento = event.option.value;
    this.cargosControl.setValue(selectedDepartamento.cargos);
    this.funcionariosDataSource.data = selectedDepartamento.funcionarios;
  }

  displayFn(departamento: any): string {
    return departamento && departamento.nombre ? departamento.nombre : '';
  }

  onSuscritoChange(event: any, funcionario: any) {
    const index = this.responsables.findIndex(f => f.codigoParticipante === funcionario.codigoParticipante);
    if (index !== -1) {
      this.responsables[index].suscrito = event.source.checked ? 1 : 0;
    }
  }

  onTitularChange(event: any, funcionario: any) {
    const index = this.responsables.findIndex(f => f.codigoParticipante === funcionario.codigoParticipante);
    if (index !== -1) {
      this.responsables.forEach(f => f.titular = 0);
      if (event.target.value=="0") {
        this.responsables[index].titular = event.target.checked ? 1 : 0;
      }
    }
  }

  onEncargadoChange(event: any, funcionario: any) {
    const index = this.responsables.findIndex(f => f.codigoParticipante === funcionario.codigoParticipante);
    if (index !== -1) {
      this.responsables.forEach(f => f.encargado = 0);
      if (event.target.value=="0") {
        this.responsables[index].encargado = event.target.checked ? 1 : 0;
      }
    }
  }

  private removeResponsablesSinRol() {
    this.responsables = this.responsables.filter(responsable =>
      responsable.titular === 1 || responsable.encargado === 1 || responsable.suscrito === 1
    );
    this.funcionariosDataSource.data = [...this.responsables];
  }

  onGuardarClick() {
    this.removeResponsablesSinRol();

    const data = {
      id: this.data?.id || 0,
      codigoDepartamento: this.dptoId || '',
      departamento: this.departamentoControl.value || '',
      cargo: this.cargosControl.value || '',
      responsables: this.responsables
    };

    if (data.id && data.id > 0) {
      this.buzonService.update(data).subscribe(() => {
        this.saving = false;
        this.dialogRef.close(data);
      });
    } else {
      this.buzonService.create(data).subscribe(() => {
        this.saving = false;
        this.dialogRef.close(data);
      },
      err => {
          const snackbarData: ScnackbarData = {
          message: err.error || "Error al agregar el registro",
          style: SnackbarStyles.Error,
          iconName: "error"
        }
        this.toast.show(snackbarData)
      }
    );
    }
  }

  onDelete(element: any) {
    const index = this.responsables.findIndex(f => f.codigoParticipante === element.codigoParticipante);
    if (index !== -1) {
      this.responsables.splice(index, 1);
      this.funcionariosDataSource.data = this.responsables;
    }
  }

  onCancelarClick() {
    this.dialogRef.close();
  }

  addResponsable(responsable: ServidorPublico) {
    const index = this.responsables.findIndex(r => r.codigoParticipante === responsable.id);
    if (index === -1) {
      this.responsables.push({
        codigoBuzon: 0,
        codigoParticipante: responsable.id,
        titular: 0,
        encargado: 0,
        suscrito: 1,
        participante: responsable.nombres + ' ' + responsable.apellidos,
      });
      this.funcionariosDataSource.data = this.responsables;
    }
  }

  displayParticipanteFn(participante: ServidorPublico): string {
    return participante && participante.nombres ? participante.nombres.trim() + ' ' + participante.apellidos.trim() : '';
  }

  private _filterParticipante(filter: string): ServidorPublico[] {
    const filterValue = filter.toLowerCase();

    return this.participantes.filter(participante =>
      participante.nombres.toLowerCase().includes(filterValue) ||
      participante.apellidos.toLocaleLowerCase().includes(filterValue) ||
      participante.cargo?.toLowerCase().includes(filterValue) ||
      participante.ciruc.includes(filterValue));
  }

  selectAllText(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }
}
